module.exports = __webpack_public_path__ + "static/media/2025_UP_Front_Communication_GR.8e914f77.png";